var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeduplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 62.912 41.763",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.178 -65.794)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M3.368 66.983h39.384v39.384H3.368z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.109 82.443v.014a4.247 4.247 0 00-.005 0 4.247 4.247 0 00-4.223 4.248 4.247 4.247 0 004.247 4.247v-.014a4.247 4.247 0 004.228-4.248 4.247 4.247 0 00-4.223-4.247 4.247 4.247 0 00-.024 0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.109 71.457v.014a3.47 3.47 0 00-3.452 3.47 3.47 3.47 0 003.47 3.472v-.015a3.47 3.47 0 003.453-3.47 3.47 3.47 0 00-3.456-3.471 3.47 3.47 0 00-.015 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.767,
    cy: 98.466,
    r: 3.471
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.109 94.981v.014a3.47 3.47 0 00-3.452 3.47 3.47 3.47 0 003.47 3.472v-.015a3.47 3.47 0 003.453-3.47 3.47 3.47 0 00-3.456-3.471 3.47 3.47 0 00-.015 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.767,
    cy: 86.704,
    r: 3.471
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 10.767,
    cy: 74.942,
    r: 4.247
  }), "{{ paintOrder: &apos;stroke markers fill&apos; }} /&gt;", /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1 1)",
    cx: -35.469,
    cy: 98.452,
    r: 3.471,
    fill: "none",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1 1)",
    cx: -35.469,
    cy: 86.69,
    r: 3.471,
    fill: "none",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.469 70.681a4.247 4.247 0 00-4.247 4.247 4.247 4.247 0 004.247 4.248 4.247 4.247 0 004.247-4.248 4.247 4.247 0 00-4.247-4.247z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.399 79.334l4.405 7.341-4.405 7.341M52.514 71.486h11.798v30.379H52.514z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.413,
    cy: 95.944,
    r: 3.471
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.413,
    cy: 87.005,
    r: 3.471
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 58.413,
    cy: 77.736,
    r: 4.247
  }))));
}

export default SvgDeduplication;